import { zodContract } from '@leprecoins/effector-sockets';
import { createReceive } from '../socket-client';
import { cashdeskBalanceSchema } from '../types';

export const receiveCashdeskBalance = createReceive(
	'cashdesk-balance',
	zodContract(cashdeskBalanceSchema),
);
